import React from 'react'

import { useField } from 'formik'

import InputMask from '../components/InputMask'
import Label from '../components/Label'
import Error from './FormItemError'
import { InputProps } from './FormikStyledInputField'

import './FormikStyles.less'

interface InputMaskProps extends InputProps {
  mask: string
}

const FormikInputMaskDefaultField: React.FC<InputMaskProps | any> = (props) => {
  const [field, meta] = useField(props)
  const showError = meta.touched && meta.error
  const error = showError ? <Error>{meta.error}</Error> : <></>

  return (
    <>
      <Label htmlFor={props.id || props.name} className=" no-select hand-on-hover">
        {props.showRequiredSign && <span className={'color-red-6 mr-4'}>*</span>}
        {props.label}
        {props.optional && <span className={'field-optional'}> (optional)</span>}
        {props.hint ? <span className="formik-field__span"> {props.hint}</span> : null}
      </Label>
      <InputMask className={`${props.className}`} {...field} {...props} />

      {error}
    </>
  )
}
export { FormikInputMaskDefaultField as InputMaskDefault }
export default FormikInputMaskDefaultField
